<template>
    <div>
      <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
          <i
            class="material-icons"
            id="menu-toggle"
            @click="isSidebar = !isSidebar"
            style="cursor:pointer"
            >view_headline</i
          >
          <app-navbar></app-navbar>
          <div class="container-fluid mt-5">
              <div class="row">
                <div class="col-sm-12">
                  <vs-breadcrumb
                    align="left"
                    :items="[
                      { title: 'You are here : ' },
                      {
                        title: 'Reports',
                        url: '/#/dashboard/communicationOfficer/allReportsCO',
                        active: false
                      },
                      {
                        title: 'Individual Analysis Report',
                        url: '/#/dashboard/communicationOfficer/individualAnalysisCO',
                        active: true
                      }
                    ]"
                  ></vs-breadcrumb>
                </div>
              </div>
              
                <IndividualAnalysis /> 
              
              
            </div>
          
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Navbar from "./Navbar";
  import Sidebar from "./Sidebar";
  import IndividualAnalysis from "../../commonPages/IndividualAnalysis";
  
  
  export default {
    data: () => ({
      
      isSidebar: false,
     
    }),
    components: {
      "app-navbar": Navbar,
      "app-sidebar": Sidebar,
      IndividualAnalysis
    },
   
  };
  </script>
  
  <style scoped>
  
  
  </style>
  